import { useEffect } from 'react'
import { Flex, Image, Typography, App } from 'antd'
import AccountDetailsIcon from "../../assets/icons/account-details.svg"
import CopyIcon from "../../assets/icons/copy.svg"
import Whatsapp from "../../assets/icons/whatsapp.svg"
import Mail from "../../assets/icons/mail.svg"
import { CheckOutlined } from "@ant-design/icons"
import { useDispatch, useSelector } from "react-redux";
import { getEscrowDetailsByOrgId, sendDepositDetails } from '../../redux/slices/ProfileSlice'
import { DESC_TXT, GLOBAL_CONSTANTS, SUCCESS_MSGS, TITLE_TXT } from '../../constants/constants'
import { capitalizeEntireWord } from '../../helpers/helpers'
import EscrowDetail from '../Details/EscrowDetail'
import "./AccountDetails.scss"
import ShareDetail from '../Details/ShareDetail'

const { Title, Text } = Typography


const AccountDetails = () => {
    const { message } = App.useApp();
    const { user } = useSelector((state) => state.auth);
    const { escrowDetailsData } = useSelector((state) => state.profile);
    const dispatch = useDispatch();


    useEffect(() => {
        dispatch(getEscrowDetailsByOrgId(user?.orgId))
    }, [dispatch, user.orgId])

    const copyable = {
        icon: [<Image preview={false} src={CopyIcon} alt='Copy Icon' key="copy-icon" />, <CheckOutlined key="copy-icon" />],
    }

    const handleSendDeposit = async () => {
        const payload = {
            email: user?.email,
            name: user?.userName,
            beneficiaryName: escrowDetailsData?.accHolderName,
            escrowBankName: escrowDetailsData?.bankName,
            escrowBranchName: escrowDetailsData?.branchName,
            escrowAccountNumber: escrowDetailsData?.accNum,
            escrowIfscCode: escrowDetailsData?.ifscCode,
        };

        const res = await dispatch(sendDepositDetails(payload))

        if (res.payload.statusCode === 200) {
            message.success(SUCCESS_MSGS.ECW_DET_SUC_MSG);
        }
    };

    return (
        <div className='account-details-container'>
            <Flex gap="small" style={{ marginBottom: 30 }}>
                <div className='bank-icon-container'>
                    <Image preview={false} src={AccountDetailsIcon} alt='Bank Icon' />
                </div>
                <Flex vertical>
                    <Title level={5}>{TITLE_TXT.ECW_DET_TXT}</Title>
                    <Text style={{ color: "#40566D", fontSize: 14 }}>{DESC_TXT.ECW_DET_TXT}</Text>
                </Flex>
            </Flex>
            <Text strong>{GLOBAL_CONSTANTS.MIN_AMT_TO_INV_TXT}</Text>
            <div className='details-container'>
                <EscrowDetail
                    vertical
                    gap="small"
                    title={TITLE_TXT.ECW_BEN_ACC_NAME}
                    descLevel={5}
                    copyable={copyable}
                    desc={capitalizeEntireWord(escrowDetailsData?.accHolderName)}
                />
                <EscrowDetail
                    vertical
                    gap="small"
                    title={TITLE_TXT.ECW_BANK_NAME}
                    descLevel={5}
                    copyable={copyable}
                    desc={capitalizeEntireWord(escrowDetailsData?.bankName)}
                />
                <EscrowDetail
                    vertical
                    gap="small"
                    title={TITLE_TXT.ECW_BRANCH_NAME}
                    descLevel={5}
                    copyable={copyable}
                    desc={capitalizeEntireWord(escrowDetailsData?.branchName)}
                />
                <EscrowDetail
                    vertical
                    gap="small"
                    title={TITLE_TXT.ECW_BANK_ACC_NUM}
                    descLevel={5}
                    copyable={copyable}
                    desc={capitalizeEntireWord(escrowDetailsData?.accNum)}
                />
                <EscrowDetail
                    vertical
                    gap="small"
                    title={TITLE_TXT.ECW_IFSC_CODE}
                    descLevel={5}
                    copyable={copyable}
                    desc={capitalizeEntireWord(escrowDetailsData?.ifscCode)}
                />
            </div>
            <Text strong>{GLOBAL_CONSTANTS.SHARE_TXT}</Text>
            <div className='share-container'>
                <ShareDetail
                    popTitle={TITLE_TXT.DEPO_DET_TO_WHATSAPP_CONFIRM_TXT}
                    onConfirm={() => { }}
                    icon={Whatsapp}
                    shareDesc={GLOBAL_CONSTANTS.WHATSAPP}
                />
                <ShareDetail
                    popTitle={TITLE_TXT.DEPO_DET_TO_EMAIL_CONFIRM_TXT}
                    onConfirm={handleSendDeposit}
                    icon={Mail}
                    shareDesc={GLOBAL_CONSTANTS.EMAIL}
                />
            </div>
        </div>
    )
}

export default AccountDetails